import React from 'react';
import { Link } from 'react-router-dom';
import { Compass, Home, Search } from 'lucide-react';
import Button from '../components/Button';
import SEO from '../components/SEO';

const NotFoundPage = () => {
  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center text-center px-4">
      <SEO 
        title="Page Not Found" 
        description="The page you are looking for does not exist."
      />
      
      <div className="w-24 h-24 rounded-full bg-brand-light border border-brand-border flex items-center justify-center mb-8 animate-pulse-slow">
        <Compass className="w-12 h-12 text-brand-cyan" />
      </div>
      
      <h1 className="text-4xl md:text-5xl font-heading font-bold text-brand-white mb-4">
        Off the Map
      </h1>
      
      <p className="text-brand-grey2 text-lg max-w-md mb-8">
        We couldn't find the page you're looking for. It might have moved or the URL might be incorrect.
      </p>
      
      <div className="flex flex-col sm:flex-row gap-4">
        <Link to="/">
          <Button>
            <Home className="w-4 h-4 mr-2" />
            Go Home
          </Button>
        </Link>
        <Link to="/careers">
          <Button variant="secondary">
            <Search className="w-4 h-4 mr-2" />
            Search Careers
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;